"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.HRAdapter = void 0;
const demarked_1 = require("@d24/demarked");
const _contracts_1 = require("../_contracts");
const adapter_1 = require("../_helpers/adapter");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
class HRAdapter {
    /**
     * Adapts (translates/maps) the passed-in `HRModule` to the `HRToken`.
     *
     * @param object - The module to adapt.
     */
    objectToToken(object) {
        const { content } = object;
        if (typeof content !== 'object') {
            throw new Error(`HRAdapter.objectToToken(): [object.content] property should be an [object], but got ${typeof content}!\nFull [object] object: ${JSON.stringify(object)}`);
        }
        const { text } = content;
        if (typeof text !== 'string') {
            throw new Error(`HRAdapter.objectToToken(): [object.content.text] property should be a [string], but got ${typeof text}!\nFull [object] object: ${JSON.stringify(object)}`);
        }
        return {
            content: text,
            raw: text,
            type: demarked_1.TokenType.HR
        };
    }
    /**
     * Adapts (translates/maps) the passed-in `HRToken` to the `HRModule`.
     *
     * @param token - The token to adapt.
     */
    tokenToObject(token) {
        const { content } = token;
        if (typeof content !== 'string') {
            throw new Error(`HRAdapter.tokenToObject(): [token.content] property should be a [string], but got ${typeof content}!\nFull [token] object: ${JSON.stringify(token)}`);
        }
        return {
            ...adapter_1.getModuleBase(),
            content: { text: content },
            driver: _contracts_1.ModuleDriver.HR
        };
    }
}
exports.HRAdapter = HRAdapter;
//# sourceMappingURL=HR.adapter.js.map